var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://isardvdi.com/","target":"_blank"}},[_c('i18n',{attrs:{"path":"views.login.powered-by","tag":"p"},scopedSlots:_vm._u([{key:"isardvdi",fn:function(){return [_c('strong',[_vm._v("IsardVDI")])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }